module.exports = __webpack_public_path__ + "static/media/SF-13-A.a19a5228.mp3";